// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planner-container {
  background: rgba(255, 255, 255, 0.3);
  margin: 15px 0px 10px 0px;
}
.planner-container .planner-child {
  padding: 5px;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
}
.planner-container .planner-empty-field {
  min-height: 50px;
}
.planner-container .planner-wrapper {
  min-height: 300px;
}
.planner-container .planner-input {
  border-radius: 8px;
  border: 0.5px solid #61b76e;
  width: 100%;
  height: 30px;
  padding: 4px;
}
.planner-container .planner-input:focus-visible {
  outline: none;
}
.planner-container .planner-input-hide {
  opacity: 0;
  height: 0;
  width: 0;
}
.planner-container .planner-input-show {
  opacity: 1;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}
.planner-container .planner-input-show svg {
  vertical-align: middle;
}
.planner-container .planner-input-show .select {
  width: 80%;
  border-color: #61b76e;
  border-radius: 8px;
  padding: 4px 0;
  font-size: 12px;
}
.planner-container .planner-input-show .select option {
  font-size: 12px;
}
.planner-container .planner-input .MuiInput-underline:before {
  border-bottom: none;
}
.planner-container .planner-input .MuiInput-underline:after {
  border-bottom: none;
}
.planner-container .planner-input .MuiInput-underline:hover {
  border-bottom: none;
}
.planner-container .planner-input .MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom: none;
}
.planner-container .planner-input-grid {
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  margin-right: 8px;
  min-width: 30%;
}
.planner-container .planner-input-grid > div {
  background: rgba(255, 255, 255, 0.3);
  padding-left: 4px;
  margin-bottom: 8px;
  border-radius: 10px;
}
.planner-container .planner-input-grid .planner-label-disabled {
  background-color: lightgray;
}
.planner-container .planner-input-grid .error-text {
  padding: 0;
  margin: 0;
  font-size: 10px;
  color: red;
}
.planner-container .planner-input-grid .error-field {
  border-color: red;
}
.planner-container .planner-empty-field {
  background: transparent !important;
}
.planner-container .planner-label {
  transition: all 0.3s ease-out;
  font-size: 12px;
  cursor: pointer;
  padding: 2px;
  margin-top: 8px;
}
.planner-container .hide-transition {
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}
.planner-container .show-transition {
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  padding-left: 4px;
}
.planner-container .input-value {
  border-radius: 45px 50px 5px 50px;
  color: #000;
  padding: 5px 5px;
  background: linear-gradient(270deg, #41b6c4 -17.61%, #7fcdbb 95.49%);
  font-size: 11px;
  text-align: center;
  margin-top: 8px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline;
}
.planner-container .output-field-value {
  background: linear-gradient(180.61deg, #016630 49.35%, #007080 90.9%);
}
.planner-container .output-field-grid {
  background: linear-gradient(270deg, #3a957d -17.61%, #a3c967 95.49%);
  border-radius: 10px;
  padding-left: 5px;
}
.planner-container .output-field-grid .planner-label {
  color: #000;
}
.planner-container .output-field-grid .output-field-value {
  background: none;
}
.planner-container .planner-label-grid {
  cursor: pointer;
  pointer-events: auto;
}
.planner-container .planner-simulate-grid {
  margin: 5px 0;
}
.planner-container .planner-simulate-grid .tile-it-button {
  margin-top: 0;
}
.planner-container .planner-simulate-grid .simulate-grid {
  position: absolute;
  left: 4px;
}
.planner-container .planner-simulate-grid .simulate-preview-header .MuiDataGrid-columnSeparator {
  display: none;
}
.planner-container .planner-simulate-grid .simulate-preview-header .MuiDataGrid-columnHeaderTitleContainer {
  padding: 0;
}
.planner-container .planner-simulate-grid .simulate-preview-header .MuiDataGrid-columnHeaderTitle {
  font-weight: bold;
  color: #555555;
  text-transform: uppercase;
}
.planner-container .planner-simulate-grid .simulate-preview {
  color: #555555;
  font-weight: bold;
  width: 100%;
  height: 400px;
}
.planner-container .planner-simulate-grid .simulate-preview .MuiDataGrid-root {
  border: none;
}
.planner-container .planner-simulate-grid .simulate-list-item {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  margin-bottom: 6px;
  font-size: 12px;
  height: 45px;
}
.planner-container .planner-simulate-grid .simulate-list-item .list-title {
  width: 60%;
  position: relative;
  z-index: 1000;
}
.planner-container .planner-simulate-grid .simulate-list-item .list-beforeId,
.planner-container .planner-simulate-grid .simulate-list-item .list-afterId {
  padding: 0;
  width: 10%;
  justify-content: right;
}
.planner-container .planner-simulate-grid .simulate-list-item .list-beforeId {
  padding: 4px;
}
.planner-container .planner-simulate-grid .simulate-list-item .MuiListItemText-primary {
  font-size: 12px;
}
.planner-container .planner-simulate-grid .simulate-list-container {
  margin-top: 30px;
}
.planner-container .planner-simulate-grid .before-after-section {
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  max-width: 35%;
}
.planner-container .planner-simulate-grid .before-after-section > div:first-child {
  margin-right: 8px;
}
.planner-container .planner-simulate-grid .before-after-section .before-title {
  font-weight: bold;
  color: #555555;
  text-transform: uppercase;
  font-size: 14px;
  color: #555555;
  border: 1px solid #555555;
  height: 350px;
  padding: 4px;
  border-style: dashed;
  border-radius: 10px;
  width: 50%;
  text-align: center;
}
.planner-container .chrono-wrapper {
  max-height: 550px;
  border: 1px solid #ffffff;
  padding: 0px 5px 5px 5px;
  border-radius: 4px;
  overflow-y: auto;
}
.planner-container .planner-add-child {
  margin: 8px 0;
  min-height: 25px;
}
.planner-container .planner-add-child svg {
  cursor: pointer;
  margin-top: 3px;
}
.planner-container .planner-add-child ul {
  display: inline-flex;
  list-style: none;
  padding: 0 8px 0 0;
  margin: 0;
}
.planner-container .planner-add-child ul > li {
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  padding: 2px 2px 3px 2px;
  background-color: #ffffff;
  margin-right: 8px;
  display: flex;
  cursor: pointer;
}
.planner-container .planner-add-child ul > li .child-item {
  margin-right: 14px;
}
.planner-container .planner-add-child ul > li .child-item .MuiRadio-root {
  padding: 0;
}
.planner-container .planner-add-child ul > li .member-item {
  padding: 1px 8px 0;
  cursor: pointer;
}
.planner-container .planner-add-child ul > li .member-item label {
  cursor: pointer;
}
.planner-container .planner-add-child ul > li .member-item .member-editable-label {
  font-size: 12px;
  padding-top: 4px;
}
.planner-container .planner-add-child ul > li .member-item .editing-text {
  border: 1px solid white;
  border-radius: 8px;
  padding: 2px 4px;
  outline: none;
}
.planner-container .planner-add-child ul .selected-child {
  background-color: #3a957d;
}
.planner-container .planner-add-child ul .selected-child label {
  color: white;
}
.planner-container .planner-add-child ul .selected-child svg {
  color: white;
}
.planner-container .planner-add-child ul .selected-child .member-editable-label {
  color: white;
}
.planner-container .planner-add-child .add-btn {
  font-weight: bold;
  background-color: white;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 0;
  min-width: 40px;
}
.planner-container .display-button {
  background: transparent;
  border: none;
  color: transparent;
  padding: 0px;
  vertical-align: middle;
}

.planner-container-parent {
  padding: 0 !important;
}

.list-menu-container {
  padding: 16px;
}
.list-menu-container .MuiPopover-paper {
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  width: 290px;
}
.list-menu-container .list-menu-item {
  padding-bottom: 8px;
}
.list-menu-container .list-menu-item .MuiSvgIcon-root {
  vertical-align: middle;
}
.list-menu-container .list-menu-item .primary-label {
  color: #1976d2;
  font-weight: bold;
}
.list-menu-container .list-menu-item span {
  font-size: 12px;
}
.list-menu-container .search-input {
  height: 20px;
  margin: 4px;
  width: 100%;
}
.list-menu-container .search-input .MuiSvgIcon-root {
  width: 16px;
  height: 16px;
}
.list-menu-container .search-input .MuiInputBase-root {
  border-radius: 13px;
}
.list-menu-container .search-input .MuiTextField-root {
  width: 100%;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 357.5%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 13px;
}
.list-menu-container .search-input .MuiTextField-root input::placeholder {
  font-size: 12px;
}
.list-menu-container .search-input .MuiTextField-root input {
  padding: 6px 0;
  font-size: 12px;
}
.list-menu-container .chrono-accordion {
  margin-top: 4px;
  padding: 16px;
}
.list-menu-container .chrono-accordion .MuiAccordionSummary-content {
  font-size: 12px;
  margin: 4px;
  font-weight: bold;
}
.list-menu-container .chrono-accordion .MuiAccordionSummary-root {
  min-height: 20px;
}
.list-menu-container .chrono-accordion .MuiAccordionDetails-root {
  padding: 2px 0 0 20px;
  font-size: 12px;
  margin-bottom: 8px;
}
.list-menu-container .chrono-accordion .chrono-accordion-title {
  color: #555555;
  padding: 0;
  margin: 0;
  font-size: 10px;
  justify-content: left;
}`, "",{"version":3,"sources":["webpack://./src/styles/planner.scss"],"names":[],"mappings":"AAAA;EAGE,oCAAA;EAEA,yBAAA;AAFF;AAGE;EACE,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKI;EACE,iBAAA;AAHN;AAKI;EACE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAHN;AAKM;EACE,aAAA;AAHR;AAKM;EACE,UAAA;EACA,SAAA;EACA,QAAA;AAHR;AAKM;EACE,UAAA;EAEA,6BAAA;EACA,qCAAA;AAJR;AAMQ;EACE,sBAAA;AAJV;AAMQ;EACE,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAJV;AAKU;EACE,eAAA;AAHZ;AAQM;EACE,mBAAA;AANR;AAQM;EACE,mBAAA;AANR;AAQM;EACE,mBAAA;AANR;AAQM;EACE,mBAAA;AANR;AAUI;EACE,mBAAA;EACA,sBAAA;EACA,gDAAA;EACA,iBAAA;EACA,cAAA;AARN;AAUM;EACE,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AARR;AAWM;EACE,2BAAA;AATR;AAWM;EACE,UAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AATR;AAWM;EACE,iBAAA;AATR;AAaI;EACE,kCAAA;AAXN;AAcE;EACE,6BAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAZJ;AAeE;EACE,6BAAA;EACA,qCAAA;AAbJ;AAgBE;EACE,6BAAA;EACA,qCAAA;EACA,iBAAA;AAdJ;AAgBE;EACE,iCAAA;EACA,WAAA;EACA,gBAAA;EAEA,oEAAA;EAEA,eAAA;EAEA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAjBJ;AAmBE;EACE,qEAAA;AAjBJ;AAmBE;EAGE,oEAAA;EACA,mBAAA;EACA,iBAAA;AAnBJ;AAoBI;EACE,WAAA;AAlBN;AAoBI;EACE,gBAAA;AAlBN;AAqBE;EACE,eAAA;EACA,oBAAA;AAnBJ;AAsBE;EAsBE,aAAA;AAzCJ;AAqBI;EACE,aAAA;AAnBN;AAqBI;EACE,kBAAA;EACA,SAAA;AAnBN;AAsBM;EACE,aAAA;AApBR;AAsBM;EACE,UAAA;AApBR;AAsBM;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;AApBR;AAyBI;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;AAvBN;AAwBM;EACE,YAAA;AAtBR;AAyBI;EACE,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAvBN;AAwBM;EACE,UAAA;EACA,kBAAA;EACA,aAAA;AAtBR;AAwBM;;EAEE,UAAA;EACA,UAAA;EACA,sBAAA;AAtBR;AAwBM;EACE,YAAA;AAtBR;AAwBM;EACE,eAAA;AAtBR;AA4BI;EACE,gBAAA;AA1BN;AA4BI;EACE,aAAA;EACA,8BAAA;EAEA,iBAAA;EACA,cAAA;AA3BN;AA4BM;EACE,iBAAA;AA1BR;AA4BM;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EAEA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AA3BR;AA+BE;EACE,iBAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;AA7BJ;AA+BE;EACE,aAAA;EACA,gBAAA;AA7BJ;AA8BI;EACE,eAAA;EACA,eAAA;AA5BN;AA8BI;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AA5BN;AA6BM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA3BR;AA4BQ;EACE,kBAAA;AA1BV;AA2BU;EACE,UAAA;AAzBZ;AA4BQ;EACE,kBAAA;EACA,eAAA;AA1BV;AA2BU;EACE,eAAA;AAzBZ;AA2BU;EACE,eAAA;EACA,gBAAA;AAzBZ;AA2BU;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAzBZ;AA6BM;EACE,yBAAA;AA3BR;AA4BQ;EACE,YAAA;AA1BV;AA4BQ;EACE,YAAA;AA1BV;AA4BQ;EACE,YAAA;AA1BV;AA8BI;EACE,iBAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AA5BN;AA+BE;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AA7BJ;;AAgCA;EACE,qBAAA;AA7BF;;AA+BA;EACE,aAAA;AA5BF;AA6BE;EAEE,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;EACA,YAAA;AA5BJ;AA+BE;EACE,mBAAA;AA7BJ;AA8BI;EACE,sBAAA;AA5BN;AA8BI;EACE,cAAA;EACA,iBAAA;AA5BN;AA8BI;EACE,eAAA;AA5BN;AA+BE;EAEE,YAAA;EACA,WAAA;EACA,WAAA;AA9BJ;AA+BI;EACE,WAAA;EACA,YAAA;AA7BN;AA+BI;EACE,mBAAA;AA7BN;AA+BI;EAIE,WAAA;EACA,8EAAA;EAKA,yBAAA;EACA,sBAAA;EACA,mBAAA;AApCN;AAyBM;EACE,eAAA;AAvBR;AAmCM;EACE,cAAA;EACA,eAAA;AAjCR;AAqCE;EACE,eAAA;EACA,aAAA;AAnCJ;AAoCI;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AAlCN;AAoCI;EACE,gBAAA;AAlCN;AAoCI;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;AAlCN;AAoCI;EACE,cAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;AAlCN","sourcesContent":[".planner-container {\r\n  // margin-top: 3em;\r\n  // margin-left: 4em;\r\n  background: rgba(255, 255, 255, 0.3);\r\n\r\n  margin: 15px 0px 10px 0px;\r\n  .planner-child {\r\n    padding: 5px;\r\n    border: 1px solid #ffffff;\r\n    box-sizing: border-box;\r\n    box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .planner-empty-field {\r\n    min-height: 50px;\r\n  }\r\n  .planner {\r\n    &-wrapper {\r\n      min-height: 300px;\r\n    }\r\n    &-input {\r\n      border-radius: 8px;\r\n      border: 0.5px solid #61b76e;\r\n      width: 100%;\r\n      height: 30px;\r\n      padding: 4px;\r\n\r\n      &:focus-visible {\r\n        outline: none;\r\n      }\r\n      &-hide {\r\n        opacity: 0;\r\n        height: 0;\r\n        width: 0;\r\n      }\r\n      &-show {\r\n        opacity: 1;\r\n        // max-height: 100%;\r\n        transition: all 0.3s ease-out;\r\n        -webkit-transition: all 0.3s ease-out;\r\n        // padding-top: 8px;\r\n        svg {\r\n          vertical-align: middle;\r\n        }\r\n        .select {\r\n          width: 80%;\r\n          border-color: #61b76e;\r\n          border-radius: 8px;\r\n          padding: 4px 0;\r\n          font-size: 12px;\r\n          option {\r\n            font-size: 12px;\r\n          }\r\n        }\r\n      }\r\n      //for date picker\r\n      .MuiInput-underline:before {\r\n        border-bottom: none;\r\n      }\r\n      .MuiInput-underline:after {\r\n        border-bottom: none;\r\n      }\r\n      .MuiInput-underline:hover {\r\n        border-bottom: none;\r\n      }\r\n      .MuiInput-underline:hover:not(.Mui-disabled):before {\r\n        border-bottom: none;\r\n      }\r\n    }\r\n\r\n    &-input-grid {\r\n      border-radius: 10px;\r\n      box-sizing: border-box;\r\n      box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n      margin-right: 8px;\r\n      min-width: 30%;\r\n      // width: 25%;\r\n      & > div {\r\n        background: rgba(255, 255, 255, 0.3);\r\n        padding-left: 4px;\r\n        margin-bottom: 8px;\r\n        border-radius: 10px;\r\n        // height: 45px; //visit again\r\n      }\r\n      .planner-label-disabled {\r\n        background-color: lightgray;\r\n      }\r\n      .error-text {\r\n        padding: 0;\r\n        margin: 0;\r\n        font-size: 10px;\r\n        color: red;\r\n      }\r\n      .error-field {\r\n        border-color: red;\r\n      }\r\n      // background: rgba(255, 255, 255, 0.3);\r\n    }\r\n    &-empty-field {\r\n      background: transparent !important;\r\n    }\r\n  }\r\n  .planner-label {\r\n    transition: all 0.3s ease-out;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    padding: 2px;\r\n    margin-top: 8px;\r\n    // -webkit-transition: all 0.3s ease-out;\r\n  }\r\n  .hide-transition {\r\n    transition: all 0.3s ease-out;\r\n    -webkit-transition: all 0.3s ease-out;\r\n    // padding: 2px;\r\n  }\r\n  .show-transition {\r\n    transition: all 0.3s ease-out;\r\n    -webkit-transition: all 0.3s ease-out;\r\n    padding-left: 4px;\r\n  }\r\n  .input-value {\r\n    border-radius: 45px 50px 5px 50px;\r\n    color: #000;\r\n    padding: 5px 5px;\r\n    //background: linear-gradient(180.61deg, #32a3b2 29.35%, #61b76e 90.9%);\r\n    background: linear-gradient(270deg, #41b6c4 -17.61%, #7fcdbb 95.49%);\r\n    // width: auto;\r\n    font-size: 11px;\r\n    // height: 25px; //visit again\r\n    text-align: center;\r\n    margin-top: 8px;\r\n    margin-right: 5px;\r\n    margin-bottom: 5px;\r\n    display: inline;\r\n  }\r\n  .output-field-value {\r\n    background: linear-gradient(180.61deg, #016630 49.35%, #007080 90.9%);\r\n  }\r\n  .output-field-grid {\r\n    //background: linear-gradient(97.83deg, #009fe3 -26.37%, #00a19a 96.45%);\r\n    //background: linear-gradient(270deg, #3a957d -17.61%, #1e4438 95.49%);\r\n    background: linear-gradient(270deg, #3a957d -17.61%, #a3c967 95.49%);\r\n    border-radius: 10px;\r\n    padding-left: 5px;\r\n    .planner-label {\r\n      color: #000;\r\n    }\r\n    .output-field-value {\r\n      background: none;\r\n    }\r\n  }\r\n  .planner-label-grid {\r\n    cursor: pointer;\r\n    pointer-events: auto;\r\n  }\r\n\r\n  .planner-simulate-grid {\r\n    // position: relative;\r\n    .tile-it-button {\r\n      margin-top: 0;\r\n    }\r\n    .simulate-grid {\r\n      position: absolute;\r\n      left: 4px;\r\n    }\r\n    .simulate-preview-header {\r\n      .MuiDataGrid-columnSeparator {\r\n        display: none;\r\n      }\r\n      .MuiDataGrid-columnHeaderTitleContainer {\r\n        padding: 0;\r\n      }\r\n      .MuiDataGrid-columnHeaderTitle {\r\n        font-weight: bold;\r\n        color: #555555;\r\n        text-transform: uppercase;\r\n      }\r\n    }\r\n    margin: 5px 0;\r\n\r\n    .simulate-preview {\r\n      color: #555555;\r\n      font-weight: bold;\r\n      width: 100%;\r\n      height: 400px;\r\n      .MuiDataGrid-root {\r\n        border: none;\r\n      }\r\n    }\r\n    .simulate-list-item {\r\n      background: rgba(255, 255, 255, 0.3);\r\n      border-radius: 8px;\r\n      margin-bottom: 6px;\r\n      font-size: 12px;\r\n      height: 45px;\r\n      .list-title {\r\n        width: 60%;\r\n        position: relative;\r\n        z-index: 1000;\r\n      }\r\n      .list-beforeId,\r\n      .list-afterId {\r\n        padding: 0;\r\n        width: 10%;\r\n        justify-content: right;\r\n      }\r\n      .list-beforeId {\r\n        padding: 4px;\r\n      }\r\n      .MuiListItemText-primary {\r\n        font-size: 12px;\r\n      }\r\n      .MuiListItemText-root {\r\n        // max-width: 30%;\r\n      }\r\n    }\r\n    .simulate-list-container {\r\n      margin-top: 30px;\r\n    }\r\n    .before-after-section {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      // padding-top: 8px;\r\n      margin-left: auto;\r\n      max-width: 35%;\r\n      & > div:first-child {\r\n        margin-right: 8px;\r\n      }\r\n      .before-title {\r\n        font-weight: bold;\r\n        color: #555555;\r\n        text-transform: uppercase;\r\n        font-size: 14px;\r\n        color: #555555;\r\n        // margin-left: 8px;\r\n        border: 1px solid #555555;\r\n        height: 350px;\r\n        padding: 4px;\r\n        border-style: dashed;\r\n        border-radius: 10px;\r\n        width: 50%;\r\n        text-align: center;\r\n      }\r\n    }\r\n  }\r\n  .chrono-wrapper {\r\n    max-height: 550px;\r\n    border: 1px solid #ffffff;\r\n    padding: 0px 5px 5px 5px;\r\n    border-radius: 4px;\r\n    overflow-y: auto;\r\n  }\r\n  .planner-add-child {\r\n    margin: 8px 0;\r\n    min-height: 25px;\r\n    svg {\r\n      cursor: pointer;\r\n      margin-top: 3px;\r\n    }\r\n    ul {\r\n      display: inline-flex;\r\n      list-style: none;\r\n      padding: 0 8px 0 0;\r\n      margin: 0;\r\n      & > li {\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n        border-radius: 20px;\r\n        padding: 2px 2px 3px 2px;\r\n        background-color: #ffffff;\r\n        margin-right: 8px;\r\n        display: flex;\r\n        cursor: pointer;\r\n        .child-item {\r\n          margin-right: 14px;\r\n          .MuiRadio-root {\r\n            padding: 0;\r\n          }\r\n        }\r\n        .member-item {\r\n          padding: 1px 8px 0;\r\n          cursor: pointer;\r\n          label {\r\n            cursor: pointer;\r\n          }\r\n          .member-editable-label {\r\n            font-size: 12px;\r\n            padding-top: 4px;\r\n          }\r\n          .editing-text {\r\n            border: 1px solid white;\r\n            border-radius: 8px;\r\n            padding: 2px 4px;\r\n            outline: none;\r\n          }\r\n        }\r\n      }\r\n      .selected-child {\r\n        background-color: #3a957d;\r\n        label {\r\n          color: white;\r\n        }\r\n        svg {\r\n          color: white;\r\n        }\r\n        .member-editable-label {\r\n          color: white;\r\n        }\r\n      }\r\n    }\r\n    .add-btn {\r\n      font-weight: bold;\r\n      background-color: white;\r\n      border: 1px solid lightgray;\r\n      border-radius: 5px;\r\n      padding: 0;\r\n      min-width: 40px;\r\n    }\r\n  }\r\n  .display-button {\r\n    background: transparent;\r\n    border: none;\r\n    color: transparent;\r\n    padding: 0px;\r\n    vertical-align: middle;\r\n  }\r\n}\r\n.planner-container-parent {\r\n  padding: 0 !important;\r\n}\r\n.list-menu-container {\r\n  padding: 16px;\r\n  .MuiPopover-paper {\r\n    // background: rgba(255, 255, 255, 0.3);\r\n    border: 2px solid #ffffff;\r\n    box-sizing: border-box;\r\n    box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n    border-radius: 10px;\r\n    width: 290px;\r\n    // height: 350px;\r\n  }\r\n  .list-menu-item {\r\n    padding-bottom: 8px;\r\n    .MuiSvgIcon-root {\r\n      vertical-align: middle;\r\n    }\r\n    .primary-label {\r\n      color: #1976d2;\r\n      font-weight: bold;\r\n    }\r\n    span {\r\n      font-size: 12px;\r\n    }\r\n  }\r\n  .search-input {\r\n    // margin: 0 0 16px 16px;\r\n    height: 20px;\r\n    margin: 4px;\r\n    width: 100%;\r\n    .MuiSvgIcon-root {\r\n      width: 16px;\r\n      height: 16px;\r\n    }\r\n    .MuiInputBase-root {\r\n      border-radius: 13px;\r\n    }\r\n    .MuiTextField-root {\r\n      input::placeholder {\r\n        font-size: 12px;\r\n      }\r\n      width: 100%;\r\n      background: linear-gradient(\r\n        180deg,\r\n        #ffffff 0%,\r\n        rgba(255, 255, 255, 0) 357.5%\r\n      );\r\n      border: 1px solid #ffffff;\r\n      box-sizing: border-box;\r\n      border-radius: 13px;\r\n\r\n      input {\r\n        padding: 6px 0;\r\n        font-size: 12px;\r\n      }\r\n    }\r\n  }\r\n  .chrono-accordion {\r\n    margin-top: 4px;\r\n    padding: 16px;\r\n    .MuiAccordionSummary-content {\r\n      font-size: 12px;\r\n      margin: 4px;\r\n      font-weight: bold;\r\n    }\r\n    .MuiAccordionSummary-root {\r\n      min-height: 20px;\r\n    }\r\n    .MuiAccordionDetails-root {\r\n      padding: 2px 0 0 20px;\r\n      font-size: 12px;\r\n      margin-bottom: 8px;\r\n    }\r\n    .chrono-accordion-title {\r\n      color: #555555;\r\n      padding: 0;\r\n      margin: 0;\r\n      font-size: 10px;\r\n      justify-content: left;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
